import React, { useState, useContext, useRef } from 'react';
import { Modal, ModalHeader, ModalBody, Button, FormGroup, Label, Form } from 'reactstrap';
import ArchivosService from '../../axios_services/archivos.service';
import Loader from '../Loader/Loader';
import { AppContext } from '../../application/provider';
import { FileMinus } from 'lucide-react';

/**
 * ModalReciboHonorariosCargoPago
 * Modal para subir el Recibo por Honorarios en el módulo RECIBO POR HONORARIOS - NEGOCIOS.
 * Disponible para perfiles: 5, 8, 22 (Talento Humano / Admin)
 */
const ModalReciboHonorariosCargoPago = ({ isOpen, onClose, onRefresh, item, periodo }) => {
    const [state] = useContext(AppContext);
    const [isLoading, setIsLoading] = useState(false);
    const [reciboFile, setReciboFile] = useState(null);
    const fileRef = useRef(null);

    if (!item) return null;

    const handleSubir = async () => {
        if (!reciboFile) {
            alert('Debe seleccionar un archivo PDF para subir.');
            return;
        }
        if (reciboFile.size > 5 * 1024 * 1024) {
            alert('El archivo excede el límite de 5MB. Por favor suba un archivo más pequeño.');
            return;
        }
        if (!window.confirm(`¿Subir Recibo por Honorarios para ${item.gestor?.toUpperCase()}?`)) return;

        setIsLoading(true);
        try {
            await ArchivosService.guardarReciboPorHonorarios(
                reciboFile,
                item.usuario_id,
                state.user.usuario_id,
                periodo
            );
            alert('Recibo por Honorarios subido correctamente.');
            setReciboFile(null);
            if (fileRef.current) fileRef.current.value = '';
            if (onRefresh) onRefresh();
            onClose();
        } catch (e) {
            console.error(e);
            alert(e.response?.data?.message || 'Error al subir el recibo. Inténtelo nuevamente.');
        } finally {
            setIsLoading(false);
        }
    };

    const handleVerRecibo = async () => {
        try {
            const recibo = await ArchivosService.getReciboPorHonorarios(item.usuario_id, periodo);
            window.open(recibo.url_completa, '_blank', 'noopener,noreferrer');
        } catch (e) {
            alert('No se pudo cargar el recibo por honorarios.');
        }
    };

    return (
        <Modal isOpen={isOpen} className="custom-modal" backdrop="static" size="md" centered>
            <ModalHeader className="modal-header">
                <div className="titulo">
                    <h1>ACTUALIZAR REGISTRO</h1>
                    <button className="close-btn" onClick={onClose}>X</button>
                </div>
            </ModalHeader>

            <div className="modal-body-footer">
                <ModalBody className="modal-body p-4">
                    {isLoading && <Loader />}

                    <Form onSubmit={(e) => { e.preventDefault(); handleSubir(); }} className="px-4 mt-2">
                        <FormGroup className="mb-3">
                            <Label>Colaborador:</Label>
                            <input
                                type="text"
                                className="form-control"
                                value={item.gestor?.toUpperCase() || ''}
                                disabled
                                style={{ backgroundColor: '#f3f4f6', cursor: 'not-allowed' }}
                            />
                        </FormGroup>

                        <FormGroup className="mb-3">
                            <Label>Periodo:</Label>
                            <input
                                type="text"
                                className="form-control"
                                value={periodo || ''}
                                disabled
                                style={{ backgroundColor: '#f3f4f6', cursor: 'not-allowed' }}
                            />
                        </FormGroup>

                        <FormGroup className="mb-4">
                            <Label>Subir Recibo por Honorarios (PDF):</Label>
                            <div className="cap-upload-zone">
                                <span
                                    className="cap-upload-btn"
                                    onClick={() => fileRef.current?.click()}
                                >
                                    {reciboFile ? reciboFile.name : 'Seleccionar archivo (PDF)'}
                                </span>
                                <input
                                    ref={fileRef}
                                    type="file"
                                    accept=".pdf"
                                    style={{ display: 'none' }}
                                    onChange={(e) => setReciboFile(e.target.files[0] || null)}
                                />
                            </div>
                            {reciboFile && (
                                <small>
                                    <span
                                        style={{ cursor: 'pointer', color: '#f87171', fontSize: '10px' }}
                                        onClick={() => { setReciboFile(null); if (fileRef.current) fileRef.current.value = ''; }}
                                    >
                                        ✕ Quitar selección
                                    </span>
                                </small>
                            )}
                        </FormGroup>

                        <div className="flex justify-end mt-4 pb-3">
                            <Button
                                className="btn-primary px-5 py-2"
                                onClick={handleSubir}
                                style={{ borderRadius: '8px' }}
                                disabled={isLoading || !reciboFile}
                            >
                                SUBIR RECIBO
                            </Button>
                        </div>
                    </Form>
                </ModalBody>
            </div>
        </Modal>
    );
};

export default ModalReciboHonorariosCargoPago;
